import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.597 35.111",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path stroke-miterlimit="10" d="M17.012.626L.589 17.347c-.168.171.012.4.315.4h7.848c.258 0 .44.172.359.338L1.169 34.259c-.141.287.438.475.678.219l19.167-20.446c.16-.171-.02-.394-.319-.394h-7.889c-.251 0-.433-.163-.364-.327L17.692.838c.117-.281-.44-.456-.68-.212z" />' }
  })
);